import React from 'react'
import { Link } from 'react-router-dom'
import SectionTitle3 from '../SectionTitle3'
import { useTranslation } from 'react-i18next'




const ServiceSection3 = ({ services, servicesIsLoading, servicesIsError }) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    const { t } = useTranslation();



    return (
        <div className={`wpo-service-area-s3 section-padding pt-0`}>
            <div className="container">
                <SectionTitle3
                    subTitle={t('sectionTitle.services.capabilities')}
                    MainTitle={t('sectionTitle.services.whatWeDo')}
                />
                <div className="row align-items-center">
                    {servicesIsLoading ? <p>{t("loading")}...</p> : servicesIsError ? <p>{t("error")}</p> : services?.slice(0, 3).map((service, sitem) => (
                        <div className="col-lg-4 col-md-6 col-12" key={sitem}>
                            <div className="wpo-service-item">
                                <div className="wpo-service-img">
                                    <img src={`${process.env.REACT_APP_API_URL}/api/images/${service?.data?.thumbnail}`} alt="" />
                                </div>
                                <div className="wpo-service-text">
                                    <h2><Link onClick={ClickHandler} to={`/service-single/${service?.slug}`}>{service?.data?.title}</Link></h2>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ServiceSection3;